import {Component, Input, OnInit} from '@angular/core';
import {TramsDataSourceService} from 'src/app/payments/service/trams-data-source.service';

@Component({
    selector: 'app-data-source-display',
    template: `{{ dataSourceName }}`,
    standalone: false
})
export class DataSourceDisplayComponent implements OnInit {
  @Input() dataSourceId: number | null = null;
  dataSourceName: string = '';

  constructor(private dataSourceService: TramsDataSourceService) {}
  ngOnInit(): void {
    if (this.dataSourceId) {
      this.dataSourceService.getTramsDataSourceList().subscribe(sources => {
        const dataSource = sources.find(ds => ds.id === this.dataSourceId);
        this.dataSourceName = dataSource?.sourceName || `${this.dataSourceId}`;
      });
    }
  }
}
